var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",class:'app' + _vm.languageType,attrs:{"id":"app"}},[(_vm.languageType == 'cn')?_c('Header'):(_vm.languageType == 'en')?_c('Headeren'):_c('Headerjp'),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.languageType == 'cn')?_c('Footer'):(_vm.languageType == 'en')?_c('Footeren'):_c('Footerjp')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85253250","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 